import { render } from "./NewVideo.vue?vue&type=template&id=82b3b602&scoped=true"
import script from "./NewVideo.vue?vue&type=script&lang=js"
export * from "./NewVideo.vue?vue&type=script&lang=js"

import "./NewVideo.vue?vue&type=style&index=0&id=82b3b602&lang=css"
import "./NewVideo.vue?vue&type=style&index=1&id=82b3b602&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82b3b602"]])

export default __exports__